import { isEmpty } from 'lodash'

// Constants
import { SEARCH_PATH_HELPERS } from 'src/constants/navigation'

export const onHomeDigestPath = pathname => {
  const homeDigestRegex =
    /^\/reports\/([-0-9A-Fa-f]{36})\/home\/([0-9A-Fa-f]{24}|)/
  const matches = pathname.match(homeDigestRegex)

  if (!matches) {
    return false
  }

  if (matches && pathname.includes('new')) {
    return false
  }

  return !isEmpty(matches)
}

export const onHomeSearchPath = pathname => {
  const matches = pathname?.match(SEARCH_PATH_HELPERS.search.regex)

  if (!matches) {
    return false
  }

  return true
}
